import { notification, Tabs, Alert, Button } from "antd";
import { useState, useEffect } from "react";
import { getStore, setStore } from "../../utils/global";
import { SettingOutlined, HighlightOutlined } from "@ant-design/icons";
import { UserStampModal } from "../UserStampModal";
import { Translate } from "../../translate";
import StampIMG from "./StampIMG";
import axios from "../../utils/axios";
import Loading from "../Loading";

const { TabPane } = Tabs;

const SettingsPage = () => {
  const [userData, setUserData] = useState(getStore("user"));
  const [musapStatus, setMusapStatus] = useState("");
  const [musapQR, setMusapQR] = useState("");
  const [musapCouplingCode, setMusapCouplingCode] = useState("");
  const [loading, setLoading] = useState({ mail: false, pass: false });
  const [mail, setMail] = useState({ disabled: true, value: "" });
  const [pass, setPass] = useState({ disabled: true, old: "", new1: "", new2: "" });
  const [err, setErr] = useState({ mail: "", old: "", new1: "", new2: "" });
  const [loadingAxios, setLoadingAxios] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [imageData, setImageData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setMail((prevMail) => ({ ...prevMail, value: userData?.kdss_email }));
    getMusapStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInfo = () => {
    axios
      .post("client/api/user/info", {})
      .then(({ data }) => {
        setStore("user", data.detail);
        setUserData(data.detail);
      })
      .catch(({ data }) => console.log(data.message));
  };

  const handleMailChange = () => {
    setMail((prevMail) => ({ ...prevMail, disabled: !prevMail.disabled }));
  };

  const handlePassChange = () => {
    setPass((prevPass) => ({ ...prevPass, disabled: !prevPass.disabled }));
  };

  const saveMailChanges = () => {
    setLoading((prevLoading) => ({ ...prevLoading, mail: true }));
    axios
      .patch("client/api/user/update", {
        kdss_email: mail.value,
        profile_image: "",
      })
      .then((res) => {
        notification.success({ message: "Success" });
      })
      .catch(({ data }) => notification.error({ message: data.message }))
      .finally(() => {
        setLoading((prevLoading) => ({ ...prevLoading, mail: false }));
        handleMailChange();
        getInfo();
      });
  };

  const savePassChanges = () => {
    setLoading((prevLoading) => ({ ...prevLoading, pass: true }));

    axios
      .patch("client/api/user/password/change", {
        old_password: pass.old,
        password: pass.new1,
      })
      .then((res) => notification.success({ message: "Success" }))
      .catch(({ data }) => notification.error({ message: data.message }))
      .finally(() => {
        setLoading((prevLoading) => ({ ...prevLoading, pass: false }));
        handlePassChange();
        getInfo();
      });
  };

  const mailChangeHandler = (e) => {
    const value = e.target.value;
    setMail((prevMail) => ({ ...prevMail, value: value }));
    setErr((prevErr) => ({ ...prevErr, mail: value === "" ? "Please fill your email" : "" }));
  };

  const passChangeHandler = (key, e) => {
    const value = e.target.value;
    setPass((prevPass) => ({ ...prevPass, [key]: value }));
    setErr((prevErr) => {
      const newErr = { ...prevErr, [key]: value.length === 0 ? "Please do not leave blank." : "" };
      if (key === "new1" || key === "new2") {
        newErr.new2 = (key === "new1" ? value : pass.new1) !== (key === "new2" ? value : pass.new2) ? "Repeat password does not matching!" : "";
      }
      return newErr;
    });
  };

  const cancelHandler = (key) => {
    setErr((prevErr) => ({ ...prevErr, [key]: "" }));
    if (key === "new2") {
      handlePassChange();
    } else {
      handleMailChange();
    }
  };

  const cancelBttnStyle = {
    marginLeft: "10px",
    background: "#eee",
    color: "black",
  };

  const handleImageList = () => {
    setLoadingAxios(true);
    axios
      .get("client/api/user/image/list", {})
      .then((e) => {
        const { list } = e.data;

        if (list.images.length > 0) {
          let images = [];
          list.images.forEach((val) => {
            axios
              .post("client/api/user/image/detail", {
                imageid: val.imageid,
              })
              .then(({ data }) => {
                images = [...images, { base64: data.data[1], id: val.imageid, shortname: val.shortname, type: val.imagetype, desc: val.description }];
                setImageData(images);
              });
          });
        }
        setLoadingAxios(false);
      })
      .catch((e) => {
        setLoadingAxios(false);
        setAlertMsg("Not upload signature");
      });
  };

  const tabsOnChange = (key) => {
    if (key === "2") handleImageList();
  };

  const getMusap = async () => {
    setLoadingAxios(true);
    axios
      .post("client/api/user/musap/linkk", {})
      .then(({ data }) => {
        getMusapStatus();
        setLoadingAxios(false);
        setMusapQR(data.data[1].qrcode);
        setMusapCouplingCode(data.data[1].couplingcode);
      })
      .catch((e) => {
        console.log("musap link error", e);
        setLoadingAxios(false);
      });
  };

  const unlinkMusap = async () => {
    setLoadingAxios(true);
    axios
      .post("client/api/user/musap/unlinkk", {})
      .then(({ data }) => {
        getMusapStatus();
        setLoadingAxios(false);
        setMusapQR("");
        setMusapCouplingCode("");
      })
      .catch((e) => {
        console.log("musap unlink error", e);
        setLoadingAxios(false);
      });
  };

  const getMusapStatus = async () => {
    setLoadingAxios(true);
    axios
      .get("client/api/user/musap/status", {})
      .then(({ data }) => {
        setLoadingAxios(false);
        setMusapStatus(data.data[1]?.status);
      })
      .catch((e) => {
        console.log("musap status error", e);
        setLoadingAxios(false);
      });
  };

  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");

  return (
    <>
      <br></br>
      <Tabs defaultActiveKey="1" className="settings-tabs-margin" type="card" onChange={tabsOnChange}>
        <TabPane
          tab={
            <span>
              <SettingOutlined />
              {Translate[ln].Settings.Menu1}
            </span>
          }
          key="1">
          <div className="container" style={{ display: "flex" }}>
            <div className="settings_page_wrapper">
              <div className="settings_box" loading={loading.pass && "1"}>
                <div className="settings_box_title"> {Translate[ln].Settings.AccountInfo}</div>
                <div className="settings_box_item">
                  <div className="settings_item_label"> {Translate[ln].Settings.Oldpass}</div>
                  <input
                    error={err.old.length > 0 && "1"}
                    type="password"
                    disabled={pass.disabled}
                    placeholder="input your old password"
                    onChange={(e) => passChangeHandler("old", e)}
                  />
                </div>
                <div className="settings_box_item">
                  <div className="settings_item_label">{Translate[ln].Settings.Newpass}</div>
                  <input
                    error={err.new1.length > 0 && "1"}
                    type="password"
                    disabled={pass.disabled}
                    placeholder="input your new password"
                    onChange={(e) => passChangeHandler("new1", e)}
                  />
                </div>
                <div className="settings_box_item">
                  <div className="settings_item_label">{Translate[ln].Settings.RepNewpass}</div>
                  <input
                    error={err.new2.length > 0 && "1"}
                    type="password"
                    disabled={pass.disabled}
                    placeholder="repeat your new password"
                    onChange={(e) => passChangeHandler("new2", e)}
                  />
                  {pass.disabled ? (
                    <button onClick={handlePassChange} className="settings_right_align" bg_color="5">
                      {Translate[ln].Settings.Changepass}
                    </button>
                  ) : (
                    <div className="settings_right_align settings_flex_bttns">
                      <button onClick={savePassChanges} disabled={err.new2.length > 0} bg_color="5">
                        Save changes
                      </button>
                      <button onClick={() => cancelHandler("new2")} style={cancelBttnStyle}>
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
                {err.new2.length > 0 && (
                  <div className="settings_box_error">
                    <div>{err.new2}</div>{" "}
                  </div>
                )}
              </div>
              <div className="settings_box" loading={loading.mail && "1"}>
                <div className="settings_box_title">{Translate[ln].Settings.ContactInfo}</div>
                <div className="settings_box_item">
                  <div className="settings_item_label"> {Translate[ln].Settings.Email}</div>
                  <input
                    onChange={(e) => mailChangeHandler(e)}
                    error={err.mail.length > 0 && "1"}
                    type="email"
                    defaultValue={userData?.kdss_email}
                    disabled={mail.disabled}
                    placeholder="input your email"
                  />
                  {mail.disabled ? (
                    <button onClick={handleMailChange} className="settings_right_align" bg_color="5">
                      {Translate[ln].Settings.ChangeEmail}
                    </button>
                  ) : (
                    <div className="settings_right_align settings_flex_bttns">
                      <button onClick={saveMailChanges} disabled={err.mail.length > 0} bg_color="5">
                        Save changes
                      </button>
                      <button onClick={() => cancelHandler("mail")} style={cancelBttnStyle}>
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
                {err.mail.length > 0 && (
                  <div className="settings_box_error">
                    <div>{err.mail}</div>{" "}
                  </div>
                )}
              </div>
            </div>
            <div
              className="new_box"
              style={{
                marginTop: "30px",
                borderStyle: "solid",
                borderColor: "lightgrey",
                borderWidth: "1px",
                width: "410px",
                height: "420px",
                borderRadius: "10px",
              }}>
              <div
                style={{
                  marginLeft: "20px",
                  marginTop: "40px",
                  fontSize: 16,
                }}>
                MUSAP Link
              </div>
              <div
                style={{
                  marginLeft: "20px",

                  marginTop: "40px",
                  borderStyle: "solid",
                  borderColor: "lightgrey",
                  borderWidth: "1px",
                  width: "360px",
                  height: "1px",
                  borderRadius: "10px",
                }}></div>
              <div className="container" style={{ display: "flex" }}>
                <div
                  className="container"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "20px",
                    marginTop: "20px",
                  }}>
                  <button
                    style={{
                      width: "100px",
                      display: musapStatus === "INACTIVE" ? "block" : "none",
                    }}
                    onClick={() => {
                      getMusap();
                      getMusapStatus();
                    }}
                    className="settings_right_align"
                    bg_color="5">
                    Link
                  </button>
                  <button
                    style={{
                      marginTop: "20px",
                      width: "100px",
                      display: musapStatus === "ACTIVE" ? "block" : "none",
                    }}
                    onClick={() => {
                      unlinkMusap();
                      getMusapStatus();
                    }}
                    className="settings_right_align"
                    bg_color="5">
                    Unlink
                  </button>
                </div>
                <div style={{ marginLeft: "30px", marginTop: "15px" }} b>
                  <div style={{ marginLeft: "95px", marginTop: "15px" }}>{musapCouplingCode}</div>
                  <img
                    src={musapQR}
                    alt="qr"
                    style={{
                      display: musapQR ? "block" : "none",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane
          tab={
            <span>
              <HighlightOutlined />
              {Translate[ln].Settings.Menu2}
            </span>
          }
          key="2">
          <div className="settings_page_wrapper">
            <div className="upload-image-button">
              <Button onClick={() => setIsOpen(true)} type="primary">
                {Translate[ln].Settings.Upload}
              </Button>
            </div>
            {alertMsg && (
              <>
                <div className="upload-image-sign">
                  <Alert message={alertMsg} type="success" />
                </div>
                <br></br>
              </>
            )}

            {imageData.length > 0 && (
              <div className="image-data-list">
                {imageData.map((val, i) => {
                  return <StampIMG key={"stamp_img_" + i} data={val} refresh={handleImageList} />;
                })}
              </div>
            )}
          </div>
        </TabPane>
      </Tabs>
      <Loading loading={loadingAxios} />
      <UserStampModal visible={isOpen} onCancel={() => setIsOpen(false)} userID={userData?.kdss_user} next={handleImageList} />
    </>
  );
};

export default SettingsPage;
